import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

// Composants
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import { AccountEntriesTableComponent } from 'src/app/accounting/components/account-entries/account-entries-table/account-entries-table.component';

// Modèles
import { AccountEntryLine } from 'src/app/@shared/models/accounting/account-entry-line.model';

// Animations
import { expandCollide } from 'src/app/@shared/animations/animations';

@Component({
    selector: 'app-account-entry-lines-panel',
    imports: [
        CommonModule,
        ButtonModule,
        TooltipModule,
        AccountEntriesTableComponent
    ],
    templateUrl: './account-entry-lines-panel.component.html',
    styleUrl: './account-entry-lines-panel.component.scss',
    animations: [expandCollide]
})
export class AccountEntryLinesPanelComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get isOpen(): boolean {
        return this.appService.accountEntryLinesPanelOpen;
    }
    public set isOpen(open: boolean) {
        this.appService.accountEntryLinesPanelOpen = open;
    }

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    public lines: AccountEntryLine[] = [];

    public get hasLines(): boolean {
        return this.lines.length > 0;
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onClickToggle(): void {
        this.isOpen = !this.isOpen;
    }

    public onClickClear(): void {
        this.accountEntryLineService.clearLines();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override subscribeToObservables(): void {
        this.subscriptions.add(
            this.accountEntryLineService.accountEntryLines$.subscribe((lines: AccountEntryLine[]) => {
                setTimeout(() => {
                    this.lines = lines;
                }, 1);
            })
        );
    }
}
